import Stomp from "stompjs";
import router from '@/router'
import {
    getToken,
    delAllData
} from "@/assets/js/basis";
import Vue from 'vue'
let v = new Vue();

let stomp = null;

//登录成功后调用此方法，通过userId创建并监听队列
export const toMQ = ((userId) => {

    var ws = new WebSocket('ws://175.27.191.97:15674/ws');
    // var ws = new WebSocket('ws://192.168.1.98:15674/ws');
    stomp = Stomp.over(ws);
    stomp.connect('zbys', 'ZBYS@2022', () => {
    // stomp.connect('zbys', 'zbys@2023', () => {
        //监听队列或交换机
        stomp.subscribe("/exchange/zbysSingle/" + userId, (msg) => {
            if (msg === null) {
            }
            if (msg.body.includes("Repeat")) {
                let token = getToken();
                v.$alert('您的账号在另一台设备登录，当前设备已下线，如果这不是本人操作，那么你的密码可能已经泄露，请尽快重新登陆并修改密码', '下线通知', {
                    confirmButtonText: '确定',
                });
                delAllData();
                closeMQ();
                router.push('login')
            }
        });

    }, () => {
    });
});
//关闭mq链接
export const closeMQ = (() => {
    delAllData();
    if (stomp != undefined) {
        stomp.disconnect(() => {})
    }
});